import { put, call } from "redux-saga/effects";
import { Actions } from "../../constants/actionTypes";
import { apiRequest } from "../../../Utils/axiosApi";

export function* apiCreateblueprints(action) {
  try {
    const result = yield call(apiRequest, {
      url: `/AWS/createBlueprint`,
      method: "POST",
      data: action.data,
    });

    const statusCode = result.status || result.response?.status;

    if (result.isApiSuccessful || statusCode === 504) {
      return { isApiSuccessful: true, data: result };
    } else {
      return { isApiSuccessful: false, data: result };
    }
  } catch (err) {
    if (err?.response?.status === 504 || err?.code === "ECONNABORTED") {
      return {
        isApiSuccessful: true,
        data: { ...err, suppressErrorPopup: true },
      };
    }
    return { isApiSuccessful: false, data: err };
  }
}

export function* apiDeleteBluePrint(action) {
  try {
    const result = yield call(apiRequest, {
      url: `/AWS/deleteBlueprint?blueprintId=${action.data.blueprintId}`,
      method: "DELETE",
    });
    if (result.isApiSuccessful) {
      return result;
    } else {
      return { isApiSuccessful: false, data: null };
    }
  } catch (err) {
    return { isApiSuccessful: false, data: err };
  }
}

export function* apiRenameBlueprints(action) {
  try {
    const result = yield call(apiRequest, {
      url: `/AWS/renameBlueprintName?newBlueprintName=${action.data.newBlueprintName}&blueprintId=${action.data.blueprintId}&orgId=${action.data.orgId}`,
      method: "PUT",
    });
    if (result.isApiSuccessful) {
      if (result.data) {
        action.meta.onSuccess();
      } else {
        action.meta.onError();
      }

      return result;
    } else {
      action.meta.onError();
      return { isApiSuccessful: false, data: null };
    }
  } catch (err) {
    action.meta?.onError();
    return { isApiSuccessful: false, data: err };
  }
}

export function* apiGetAllBlueprints(action) {
  try {
    const result = yield call(apiRequest, {
      url: `/AWS/getAllBlueprintsByOrgId?orgId=${action.data.orgId}`,
      method: "GET",
    });

    if (result.isApiSuccessful) {
      yield put({
        type: Actions.SET_GET_ALL_BLUEPRINT,
        data: {
          data: result.data,
          isApiSuccessful: result.isApiSuccessful,
          status: result.status,
        },
      });

      return result;
    } else {
      return { isApiSuccessful: false, data: null };
    }
  } catch (err) {
    action.meta.onError();
    return { isApiSuccessful: false, data: err };
  }
}

export function* apiIsValidBlueprintName(action) {
  try {
    const result = yield call(apiRequest, {
      url: `/AWS/isValidBlueprintName?blueprintName=${action.data.blueprintName}&&orgId=${action.data.orgId}`,
      method: "GET",
    });
    if (result.isApiSuccessful) {
      return result;
    } else {
      return { isApiSuccessful: false, data: null };
    }
  } catch (err) {
    return { isApiSuccessful: false, data: err };
  }
}

export function* apiGetAllSpecificBlueprints(action) {
  try {
    const result = yield call(apiRequest, {
      url: `/AWS/getAllBlueprintsByOrgId?orgId=${action.data?.orgId}`,
      method: "GET",
    });

    if (result.isApiSuccessful) {
      yield put({
        type: Actions.SET_GET_ALL_SPECIFIC_BLUEPRINT,
        data: {
          isApiSuccessful: result.isApiSuccessful,
          data: result.data,
        },
      });
    } else {
      yield put({
        type: Actions.SET_GET_ALL_SPECIFIC_BLUEPRINT,
        data: {
          isApiSuccessful: result.isApiSuccessful,
          data: null,
        },
      });
    }
    return result;
  } catch (err) {
    yield put({
      type: Actions.SET_GET_ALL_SPECIFIC_BLUEPRINT,
      data: {
        isApiSuccessful: null,
        data: null,
      },
    });
  }
}

export function* apiImageUploadBluePrint(action) {
  try {
    const result = yield call(apiRequest, {
      url: `/AWS/imageUploadBlueprint`,
      method: "POST",
      data: action.data,
    });
    if (result.isApiSuccessful) {
      return result;
    } else {
      return { isApiSuccessful: false, data: null };
    }
  } catch (err) {
    return { isApiSuccessful: false, data: err };
  }
}

export function* apiRemoveBluePrintImage(action) {
  try {
    const result = yield call(apiRequest, {
      url: `/AWS/removeBlueprintImage?blueprintId=${action.data.blueprintId}`,
      method: "DELETE",
    });
    if (result.isApiSuccessful) {
      return result;
    } else {
      return { isApiSuccessful: false, data: null };
    }
  } catch (err) {
    return { isApiSuccessful: false, data: err };
  }
}
